<template>
  <div v-if="goodsCategoryTree.length" class="user-profile container">
    <div class="user-info">
      <strong>商品分类</strong>
      <div class="user-buttons" style="margin-left: 20px;">
        <template v-for="item in goodsCategoryTree">
          <router-link :key="item.category_id" :to="{ path: '/list', query: { category_id: item.category_id, level: item.level } }" target="_blank">{{ item.category_name }}</router-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Config from "@/utils/config"
import { mapGetters } from 'vuex';
import { tree } from "@/api/goods/goodscategory"

export default {
  name: 'category-info',
  data: () => ({
    goodsCategoryTree: [],
  }),
  computed: {
  },
  created() {
    this.getTree()
  },
  methods: {
    getTree() {
      tree({
        level: 3,
        template: 2
      })
        .then((res) => {
          if (res.code == 0 && res.data) {
            this.goodsCategoryTree = res.data
          }
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
  }

};
</script>

<style lang="scss">
.user-profile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: #ffffff;
  margin: 20px 0;
  border-radius: 8px;

  .user-info {
    display: flex;

    .user-name {}
  }

  .user-buttons a {
    // color: $base-color!important;
  }

  .user-buttons a,
  .other-buttons a {
    // color: #333;
    text-decoration: none;
    margin: 0 10px;
    font-weight: 500;
  }

  .user-buttons a:hover,
  .other-buttons a:hover {
    text-decoration: underline;
    color: $base-color !important;
  }
}
</style>
